import baseApi from './http/baseApi'

var department = null

export function byCollegeDetails () {
  localStorage.getItem('byCollegeDetails')
}

export function updateDepartment () {
  baseApi.getDepartment()
    .then(res => {
      console.log('updateDepartment', res)
      if (res) {
        department = res
        localStorage.setItem('department', JSON.stringify(department))
      }
    }).catch(e => {
  })
}


export default {
  collegeid: '',
  currentNav: '',
  byCollegeDetails: null,
  department: department,
  updateDepartment: updateDepartment
}



// WEBPACK FOOTER //
// ./src/config.js